import { DiameterVariantIcon } from './DiameterVariantIcon';

/**
 * author: Michael Richins
 * id B1744A41-3289-4535-81F8-E23617C701FE
 * name diameter-variant
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diameter-variant.svg
 * tags
 * - Math 
 */
export const CircleDiameterVariantIcon = DiameterVariantIcon;
export default CircleDiameterVariantIcon